import {
  DASHBOARD_FILES_COUNT,
  DASHBOARD_FILES_COUNT_SUCCESS,
  DASHBOARD_FILES_COUNT_ERROR,
} from "./actionTypes"

export const dashboardFilesCount = data => ({
  type: DASHBOARD_FILES_COUNT,
  payload: data
});

export const dashboardFilesCountSuccess = data => ({
  type: DASHBOARD_FILES_COUNT_SUCCESS,
  payload: {data}
});

export const dashboardFilesCountError = error => ({
  type: DASHBOARD_FILES_COUNT_ERROR,
  payload: error,
});
